import request from 'server'
import apiMenuModule from './menu'
import apiDictionaryModule from './dictionary'
import apiJurisdictionModule from './jurisdiction'
import apiNewJurisdiction from './newJurisdiction'
import apiPaySlip from './paySlip'
import newEmployee from './newEmployee'
import { Method } from 'axios'
/**
 * 登录
 * @param data
 * @returns
 */
const login = (data: any) => {
  return request({
    url: '/auth/login',
    method: 'post',
    data,
  })
}
/**
 * 扫码登录
 * @param data
 * @returns
 */
const scanWecom = (data: any) => {
  return request({
    url: '/auth/sso/wecom',
    method: 'post',
    data,
  })
}
/**
 * 获取验证码
 * @returns
 */
const verificationCode = (data: { phoneNumber: string; type: number }) => {
  return request({
    url: '/external-api/sms/sendPhoneCode',
    method: 'post',
    data,
  })
}
/**
 * 修改密码
 * @param data
 * @returns
 */
const updatePwd = (data: { phone: string; code: string; newPass: string }) => {
  return request({
    url: '/system/user/changePass',
    method: 'post',
    data,
  })
}
const userInfo = () => {
  return request({
    url: '/system/user/getUserInfo',
    method: 'get',
  })
}
// 获取当前用户信息
const currUserInfo = () => {
  return request({
    url: '/system/role/authUser/selectUserByRoleRecruitmenterShopDept',
    method: 'get',
  })
}
// 上传obs
const upload = (method?: Method, packageName?: string) => {
  return request({
    url: '/file/obs',
    method: method || 'get',
    data: { packageName },
  })
}
// 识别发票
const getInvoiceFP = (data: any) => {
  return request({
    url: '/external-api/baiduCensor/vatVoice',
    method: 'post',
    data,
  })
}
// 检查审批发票
const checkExamineInvoice = (data: any) => {
  return request({
    url: '/workflow/oaExamine/checkExamineInvoice',
    method: 'post',
    data,
  })
}
// 上传人员名单
const importPersonList = (data: any) => {
  return request({
    url: '/member/serviceMsg/importPersonList',
    method: 'post',
    data,
  })
}
// 获取门市下的招聘员
export const getShopRecruiter = (deptIds: string[], roleKeys?: string[]) => {
  return request({
    url: '/system/user/queryChildrenOrSelfInOrganizationWithDeptIdsAndRoles',
    method: 'post',
    data: {
      deptIds,
      roleKeys: roleKeys || ['recruitmenter'],
    },
  })
}
// 配置中心 - 企业配置获取驻厂管理员
export const getCustomer = (data: any) => {
  return request({
    url: '/customer/customerService/queryChildrenOrSelfInOrganizationWithDeptIdsAndRoles',
    method: 'post',
    data,
  })
}
// 获取全部推广计划

export const getPlanListForPoster = () => {
  return request({
    url: '/system/qwPlan/getPlanListForPoster',
    method: 'post',
    data: {
      status: 1,
    },
  })
}
// 海报管理列表
export const getSysPosterDetails = (data: any) => {
  return request({
    url: '/system/sysPoster/getSysPosterDetails',
    method: 'post',
    data,
  })
}
// 海报管理-新增海报
export const addPoster = (data: any) => {
  return request({
    url: '/system/sysPoster',
    method: 'post',
    data,
  })
}
// 海报管理-编辑海报
export const editPoster = (data: any, posterId: string) => {
  return request({
    url: `/system/sysPoster/${posterId}`,
    method: 'PUT',
    data: { ...data, posterId },
  })
}
// 海报管理-新增海报
export const getPosterDetail = (posterId: string) => {
  return request({
    url: `/system/sysPoster/${posterId}`,
    method: 'get',
    data: {},
  })
}
// 下载次数统计
export const downloadCountIncrement = (posterId: string) => {
  return request({
    url: `/system/sysPoster/downloadCountIncrement`,
    method: 'post',
    data: { posterId },
  })
}

// 海报素材查询
export const getSysPosterMaterial = (data: {
  useDepartmentId: string
  useType: number
  title?: string
}) => {
  return request({
    url: '/system/sysPoster/getSysPosterMaterial',
    method: 'post',
    data,
  })
}
// 计提管理-获取部门人员下拉树列表
export const getSystemRecruitTreeDeptUser = (data: {
  month: string
  roleKey: string
}) => {
  return request({
    url: '/system/recruit/treeDeptUser',
    method: 'post',
    data,
  })
}
// 计提管理-修改计提角色
export const getSystemRecruitUpdateRole = (data: IeditProvisionRoleParams) => {
  return request({
    url: '/system/recruit/updateRole',
    method: 'post',
    data,
  })
}
// 发送报告状态
export const getMonthReportstatus = (data: any) => {
  return request({
    url: '/provision/provisionMsg/getMonthReportStatus',
    method: 'post',
    data,
  })
}
export const reportSendStatus = (data: any) => {
  return request({
    url: '/provision/provisionMsg/reportSendStatus',
    method: 'post',
    data,
  })
}

// 计提导入数据
export const provisionImportList = (data: any) => {
  return request({
    url: '/provision/provisionImport/list',
    method: 'post',
    data,
  })
}

export const sendReportMsg = (data: any) => {
  return request({
    url: '/provision/provisionMsg/sendReportMsg',
    method: 'post',
    data,
  })
}

// 申诉发起
export const provisionDemurInfoSave = (data: any) => {
  return request({
    url: '/provision/provisionDemurInfo/save',
    method: 'post',
    data,
  })
}

// 获取当前登录人门店下的招聘员
export const getRecruitmentByLoginUserAndMonth = (data: any) => {
  return request({
    url: '/system/recruit/getRecruitmentByLoginUserAndMonth',
    method: 'post',
    data,
  })
}
// 申诉列表
export const provisionDemurInfoList = (data: any) => {
  return request({
    url: '/provision/provisionDemurInfo/list',
    method: 'post',
    data,
  })
}

// 申诉详情
export const provisionDemurInfoDetail = (data: any) => {
  return request({
    url: '/provision/provisionDemurInfo/detail',
    method: 'post',
    data,
  })
}

// 申诉编辑
export const provisionDemurInfoEdit = (data: any) => {
  return request({
    url: '/provision/provisionDemurInfo/edit',
    method: 'post',
    data,
  })
}

// 月度计提确认信息状态查询

export const confirmForManagerStatus = (data: any) => {
  return request({
    url: '/provision/provisionMsg/confirmForManager/status',
    method: 'post',
    data,
  })
}

export const confirmForManagerSend = (data: any) => {
  return request({
    url: '/provision/provisionMsg/confirmForManager/send',
    method: 'post',
    data,
  })
}

/**
 * 计提 - 考勤系数
 * @param parentId
 * @returns
 */

export const attendanceCoefficientDetail = (data = {}) => {
  return request({
    url: '/provision/provisionRule/attendanceCoefficient/detail',
    method: 'post',
    data,
  })
}

export const attendanceCoefficientSave = (data: any) => {
  return request({
    url: '/provision/provisionRule/attendanceCoefficient/save',
    method: 'post',
    data,
  })
}

/**
 * 特定安置计提
 * @param parentId
 * @returns
 */

export const specialArrangerDetail = (data = {}) => {
  return request({
    url: '/provision/provisionRule/specialArranger/detail',
    method: 'post',
    data,
  })
}

export const specialArrangerSave = (data: any) => {
  return request({
    url: '/provision/provisionRule/specialArranger/save',
    method: 'post',
    data,
  })
}

// 获取省
export const getProvinceList = (parentId: string = '') => {
  return request({
    url: '/system/region/findRegionById',
    method: 'post',
    data: { parentId },
  })
}
// 获取全国省市区三级 带全域
export const getRegionTree = () => {
  return request({
    url: '/system/region/getRegionTree',
    method: 'post',
    data: {},
  })
}
// 获取门店下拉树三级 带全域
export const getTreeSelectForShop2 = () => {
  return request({
    url: '/system/dept/treeSelectForShop2',
    method: 'get',
    data: {},
  })
}

// 权限导出数据列表
export const exportRecordList = (data: any) => {
  return request({
    url: '/workflow/exportRecord/getList',
    method: 'post',
    data,
  })
}

//
export const getDownloadUrl = (data: any) => {
  return request({
    url: '/workflow/exportRecord/getDownloadUrl',
    method: 'post',
    data,
  })
}

// 根据当前登录人查询权限下对应区域列表
export const getRegionList = () => {
  return request({
    url: '/recruitment/customerServiceDataPermission/getServiceAreaByLoginUser',
    method: 'post',
    data: {},
  })
}
const api = {
  login,
  scanWecom,
  verificationCode,
  updatePwd,
  upload,
  getInvoiceFP,
  checkExamineInvoice,
  importPersonList,
  userInfo,
  currUserInfo,
  ...apiMenuModule,
  ...apiDictionaryModule,
  ...apiJurisdictionModule,
  ...apiNewJurisdiction,
  ...apiPaySlip,
  ...newEmployee,
}

export default api
